import type { FaireProductEntity } from "../../entity_types/product";

export const p_qfe5zdjmt4: FaireProductEntity = {
  token: "p_qfe5zdjmt4",
  type: "product",
  name: "Scandinavian Gatherings: 70  Recipes for Year-Round Hygge",
  brandToken: "b_dp7uqthd78",
  brandName: "Blue Star Press",
  imageUrl:
    "https://cdn.faire.com/fastly/dd84e09b0dfce419977eb1e2edeb7baf6a34f79f3a14d7f73973ac4893b863a6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc1efcb2a73c2e84dd02aed45e79fbccbe6db1bb8ba3e9780a21bcb0cab603ab.jpeg",
    "https://cdn.faire.com/fastly/81195c5b50bab190696496dfca0ca57056acd36fe2ea1afd0dff759ad5fa800b.jpeg",
    "https://cdn.faire.com/fastly/cfab0e084980a0361a98610c04b261feb1a77824abec92f2f96913e16175bf64.jpeg",
    "https://cdn.faire.com/fastly/c04cc34b4428caf02f536066dc619b24232be7511664f5dc5de64a49effb6fc2.jpeg",
    "https://cdn.faire.com/fastly/c648b7fc2929a3e6d1bbf427825a084ed4c877ae51bb1c65d9d7ff07a9bb3d03.jpeg",
    "https://cdn.faire.com/fastly/18e7e4db1f87e021435c3f50f8a2334cbb920b231199ff7a1bd1e45ed371e8be.jpeg",
    "https://cdn.faire.com/fastly/d625f6e92dfc179def6e28fdf15dfe56635ad0a17c9d762192480f7114b488f4.jpeg",
    "https://cdn.faire.com/fastly/478352216fb49606ca64351b0e586ba9eaba8c38076abd2c49d5adb402de4302.jpeg",
    "https://cdn.faire.com/fastly/ff7d2dc03bb7ae1445a25ad58cb76fa2ec0ce1b8350eeccc576eb4ea05c293d7.jpeg",
    "https://cdn.faire.com/fastly/64b910e23eb18803bf64b340bb27300e13dee67938a2fbca5b9d0b6be2022d7a.jpeg",
  ],
  priceDollars: 12.48,
  description:
    "Enjoy holidays the Scandinavian way with seasonal, family-friendly food and crafts! Whether you're a fan of whimsical modern Scandinavian style or have Scandinavian heritage yourself, you'll love this hygge handbook for creating cozy celebrations with family and friends.\n\n• 256-page paperback with seasonal Scandinavian recipes and DIY crafts\n• Highlights beloved holidays like Lucia Day and Christmas Eve dinner\n• Features tips on hosting Fika and other cozy gatherings year-round\n• Appeals to fans of Nordic design, food, and slow living lifestyle\n\nCategories: books, gifts, coffee table books, cookbooks, cook, chef, gifts for adults, nordic books, scandinavian gifts, well-read, mothers day ",
  tags: [],
  msrpDollars: 24.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:11.121Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
